/* clean-up of the mess from lookup */

import React, {EventHandler} from 'react';
import {useState} from 'react';
import {Autocomplete, Chip, CircularProgress, MenuItem, TextField, Tooltip} from "@mui/material";
import {Clear, PropaneSharp} from "@mui/icons-material";
import {Select as MaterialSelect} from "@mui/material";
// clean-up of the mess from select
/*
export interface IDObject {
    id: number | string,

    [key: string]: any
}

export interface IDObjects extends Array<IDObject> {
}
*/


export interface CallbackFuncProps {
    target: {
        name: string,
        value: string
    }
}

export interface SelectProps<Type extends { id: any }> {
    value: Type | Type[]|null,
    onChange: (CallbackFuncProps) => void,
    name: string,
    valueIsId?: boolean,
    labelField?: string,
    className?: string,
    defaultOption?: Type | number | string,
    options: Type[],
    allowBlank?: boolean,
    filterOptions?: (options: Type[]) => Type[],
    blankLabel?: string,
    disabled?: boolean,
    renderOption?: any,
    label?: string,
    setSearchTerm?: ((string) => void),
    renderOptionString?: (object: Type) => string,
    width?: any,
    autoFocus?:boolean,
    fill?: boolean,
    loading?: boolean,
    multiple?: boolean,
    simpleSelect?: boolean
    error?: boolean
    onBlur?: EventHandler<any>
    readOnly?: boolean
    minWidth?: string
    inTable?: boolean
}

export function Select<Type extends { id: any }>({
                                                     name,
                                                     labelField = 'name',
                                                     label = '',
                                                     value,
                                                     className = '',
                                                     onChange,
                                                     options = [],
                                                     filterOptions,
                                                     multiple = false,
                                                     allowBlank = false,
                                                     blankLabel,
                                                     renderOptionString = undefined,
                                                     disabled = false,
                                                     setSearchTerm = undefined,
                                                     width,
                                                     autoFocus = false,
                                                     fill = false,
                                                     loading = false,
                                                     simpleSelect = false,
                                                     onBlur = undefined,
                                                     inTable = false,
    minWidth=undefined,
    error=false,
    readOnly=false,
    valueIsId=true,
                                                 }: SelectProps<Type>
): JSX.Element {
    const currentOptions = options;
    const valueArray = value as unknown as Type[] | number[] | string[] ?? [];
    console.log('RENDER S2', name,multiple, value,error);
    const doRenderString = renderOptionString?renderOptionString:(option) => {
        if(typeof(option)=='string') return option;
        if(!option[labelField]) return '--';
        return option[labelField];
    };

    if (!Array.isArray(currentOptions)) {
        return <div>An error has occurred</div>;
    }

    function isSelected(id): boolean {
        if (multiple) {
            return !!(valueArray as Type[]).find((option) => option.id == id);
        } else {
            return (value as Type).id == id;
        }
    }

    const areItemsEqual = ((a, b) => {
        return a?.id == b?.id;
    });
    const itemSelect = (evt, newValue, reason) => {
        //let value = evt.target.value;
        switch (reason) {
            case 'clear':
                newValue = multiple ? [] : null;
                break;
            case 'removeOption':
            case 'selectOption':
                break;
        }
        console.log('S4', onChange, evt, newValue);
        onChange({target: {name: name, value: newValue}})
    }
    console.log('CACCSREN', currentOptions,minWidth,value);
    try {
        if (!simpleSelect) {
            const style = {minWidth:minWidth};
            return (<Autocomplete
                    options={currentOptions}
                    getOptionLabel={doRenderString}
                    disabled={disabled}
                    getOptionDisabled={(option) => option.is_locked === true}
                    readOnly={readOnly}
                    renderOption={(props, option) => {
                        return (
                          <li {...props} key={option.id}>
                            {doRenderString(option)}
                          </li>
                        );
                      }}                    
                    noOptionsText="No results."
                    className={className}
                    disableCloseOnSelect={multiple}
                    multiple={multiple}
                    blurOnSelect={false}
                    clearOnBlur={true}
                    loading={loading}
                    clearIcon={allowBlank ? <Clear/> : null}
                    fullWidth={fill}
                    sx={style}
                    openOnFocus={true}
                    onInputChange={setSearchTerm}
                    filterOptions={
                        (b,filter)=>{
                            if(setSearchTerm) {
                                console.log('filtering11 A',b);
                                return b;
                            } else {
                                const searchTerm = filter?.inputValue?.toLowerCase();
                                const c = b.filter((value)=>filter.getOptionLabel(value)?.toLowerCase()?.indexOf(searchTerm)>-1);
                                console.log('filtering11 B',b,c);
                                return c;
                            }
                        }
                    }
                    renderTags={(value, getTagProps) =>
                        value.map((option, index) => (
                            <Chip
                                variant="outlined"
                                label={doRenderString(option)}
                                size="small"
                                {...getTagProps({index})}
                                key={index}
                            />
                        ))
                    }
                    renderInput={(params) => {
                        console.log('PARAMS',label,params);
                        /*if(!value) {
                            if(setSearchTerm && !value) { params.inputProps.value = searchTerm; }
                        }*/
                        return(<TextField {...params} label={label} variant="filled"
                                   inputProps={{
                                       ...params.inputProps,
                                       fullWidth: !!fill,
                                       autoComplete: "off",
                                       form:{
                                        autoComplete:"off"
                                      }
                                   }}
                                   error={error}
                                   onFocus={event => {
                                       event.target.select();
                                   }}
                                   autoFocus={autoFocus}
                                   InputProps={{
                                       ...params.InputProps,
                                       endAdornment: (
                                           <React.Fragment>
                                               {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                               {params.InputProps.endAdornment}
                                           </React.Fragment>
                                       )
                                   }}
                        />);
                                }
                    }
                    onBlur={onBlur}

                    value={value}
                    isOptionEqualToValue={areItemsEqual}
                    onChange={itemSelect}/>
            );
        } else {
            /*
            function selectChange(evt) {
                const valueId = evt.target.value;
                // even valueIsId expects the value to be in the data returned, so... meh
                const newOption = currentOptions.find((option) => option.id == valueId);
                onChange({target: {name: name, value: newOption}});
            }
*/
            // the select expects values to be an array of IDs.
            // Also the dropdown value may be displayed before the search, so first populate the list with the original value as the option
            /*if (multiple) {
                if ((!currentOptions || !currentOptions.length) && value) {
                    currentOptions = value as Type[];
                }
                if (value) {
                    value = value.map((v) => v.id);
                }
            } else {
                if ((!currentOptions || !currentOptions.length) && value) {
                    currentOptions = [value as any];
                }
                value = value?.id;
            }*/
            console.log('SID SEL value is', value || value === 0 || value === '0' ? value : null, value, currentOptions);
            return (<Autocomplete
                options={currentOptions}
                getOptionLabel={doRenderString}
                disabled={!!disabled}
                noOptionsText="No results."
                className={className}
                disableCloseOnSelect={multiple}
                multiple={multiple}
                loading={loading}
                clearIcon={allowBlank ? <Clear/> : null}
                fullWidth={fill}
                readOnly={!!readOnly}
                openOnFocus={true}
                sx={{minWidth:minWidth??'10rem'}}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                        <Chip
                        key={index}
                        variant="outlined"
                            label={option[labelField]}
                            size="small"
                            {...getTagProps({index})}
                        />
                    ))
                }

                renderInput={(params) => (
                    <TextField {...params} label={label} variant="filled"
                               inputProps={{
                                   ...params.inputProps,
                                   readOnly: true,
                                   fullWidth: !!fill,
                                   autoComplete: "new-password"
                               }}
                               error={error}
                               autoFocus={autoFocus}
                               InputProps={{
                                   ...params.InputProps,
                                   endAdornment: (
                                       <React.Fragment>
                                           {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                           {params.InputProps.endAdornment}
                                       </React.Fragment>
                                   )
                               }}
                    />
                )}
                value={value}
                isOptionEqualToValue={areItemsEqual}
                onChange={itemSelect}/>);

        }
    } catch (e) {
        console.log('[GLookup]', 'error', e);
        return <span>An error has occurred.</span>
    }
}

